const STORAGE_KEY = 'beyable_flags';
export const NEW_PARSER_KEY = 'usenewparser';
const NEW_PARSER_LABEL = 'Use new parser';
export const FORCE_NEW_PARSER = true;

const safeRead = (): any[] => {
    try {
        const v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(v) ? v : [];
    } catch {
        return [];
    }
};

const safeWrite = (flags: any[]) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
    } catch {}
};

export function initNewParserDefaultOn() {
    const flags = safeRead().filter(f => f?.key !== NEW_PARSER_KEY);
    flags.push({ label: NEW_PARSER_LABEL, key: NEW_PARSER_KEY, enabled: true });
    safeWrite(flags);
}

export function isNewParserEnabled(): boolean {
    return FORCE_NEW_PARSER || safeRead().some(f => f?.key === NEW_PARSER_KEY && f?.enabled === true);
}